import type { ScenarioViewData } from './scenarioLens.types';

/** Scenario deviation with no selected lenses cannot render lens tabs or table columns. */
export const isPpaScenarioViewMetadataUnusable = (metadata: ScenarioViewData): boolean => {
    const hasSelectedLens = metadata.lenses.some((lens) => lens.is_selected);
    if (!hasSelectedLens) {
        return true;
    }

    const hasEnabledColumns = (metadata.column_visibility ?? []).some((column) => column.is_display_enabled);
    return !hasEnabledColumns;
};

/**
 * Detect a partial scenario deviation left after create+delete custom lens (Price-only
 * mapping) when the base saved view still has more selected lenses.
 */
export const isPpaScenarioViewMetadataDegraded = (
    scenarioMetadata: ScenarioViewData,
    baseViewMetadata: ScenarioViewData,
): boolean => {
    const scenarioSelected = scenarioMetadata.lenses.filter((lens) => lens.is_selected);
    const baseSelected = baseViewMetadata.lenses.filter((lens) => lens.is_selected);

    if (scenarioSelected.length === 0 || baseSelected.length === 0) {
        return false;
    }
    if (scenarioSelected.length >= baseSelected.length) {
        return false;
    }

    const scenarioSelectedIds = new Set(scenarioSelected.map((lens) => lens.lens_id));
    const baseSelectedIds = new Set(baseSelected.map((lens) => lens.lens_id));
    for (const lensId of scenarioSelectedIds) {
        if (!baseSelectedIds.has(lensId)) {
            return false;
        }
    }

    const visibilityLensIds = new Set(
        (scenarioMetadata.column_visibility ?? [])
            .filter((column) => column.is_display_enabled)
            .map((column) => column.lens_id),
    );
    if (visibilityLensIds.size > 1) {
        return false;
    }
    if (visibilityLensIds.size === 1) {
        const [onlyLensId] = visibilityLensIds;
        if (!scenarioSelectedIds.has(onlyLensId)) {
            return false;
        }
    }

    return true;
};
